import styled from 'styled-components'
import ErrorOutline from '@material-ui/icons/ErrorOutline'
import { px2rem, theme, colors } from '../../../../../theme/Global'

export const PopoverContent = styled.div`
  font-size: ${px2rem(15)}rem;
  &&& {
    color: ${theme.colors.text};
    margin: 1.3rem;
  }
`

const popoverStyle = { margin: '0' }

const paperStyle = {
  margin: '0',
  borderRadius: `${px2rem(5)}rem`,
  backgroundColor: colors.white,
  width: '45%',
  maxWidth: `${px2rem(750)}rem`
}

export const settingsPopoverStyles = {
  popover: popoverStyle,
  paper: paperStyle
}

export const PopoverWrapper = styled.div`display:inline-block`

export const FlippedErrorOutline = styled(ErrorOutline)`
    transform: rotate(180deg);
`
